import Calculator from "../components/creditCalculator/Calculator";

const CalculatorPage = () => {
  return (
    <div className="min-h-screen p-1 bg-transparent">
      <div className="space-y-8 max-w-screen xl:w-1/2 mx-auto">
        <Calculator />
      </div>
    </div>
  );
};

export default CalculatorPage;
